export type { SelectableIconChipProps } from './SelectableIconChip'
export { SelectableIconChip } from './SelectableIconChip'
